import * as getNotifications from './reducers/get';
import * as expiration from './reducers/expiration';

// eslint-disable-next-line import/no-default-export
export default {
    NOTIFICATIONS_WATCH_EXPIRATION: expiration.watch,
    NOTIFICATIONS_GET_REQUEST: getNotifications.request,
};
